import { Component, EventEmitter, Output, Input } from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { UserService } from './user-service';
import { MessageComponent, BaseComponent } from './../common/common-components';
import { ModalService } from "../services/modal-service";
import { BankAccountService } from "./../accounts/bank-account-service";

@Component({
    selector: 'dk-user-password-change',
    template: require('./user-password-change.html'),
    //directives: [FormInlineRowComponent, MessageComponent],
    entryComponents: [FormInlineRowComponent]
})

export class UserPasswordChangeComponent extends BaseComponent {
    changePasswordFormSuccess: boolean;
    public errorMessageId: string;
    @Input() smsMode: boolean;
    @Output() smsModeChange = new EventEmitter<boolean>();

    changePasswordForm: FormGroup = new FormGroup({
        currentPassword: new FormControl('', [Validators.required], [this.validateCurrentPassword()]),
        newPassword: new FormControl('', [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(".*[A-Z].*"),
            Validators.pattern(".*[a-z].*"),
            Validators.pattern(".*[0-9].*")
        ]),
        newPasswordConfirmation: new FormControl('', [this.validatePasswordConfirmation(), Validators.required]),
        SmsCode: new FormControl('')
    });

    constructor(private bankAccountService: BankAccountService,
        private modalService: ModalService,
        private userService: UserService) {
        super();
    }

    changePassword() {
        if (this.smsMode == true) {
            return;
        }

        this.touchFormGroup(this.changePasswordForm);

        if (this.changePasswordForm.valid) {
            this.changePasswordFormSuccess = false;
            this.bankAccountService.isAccountBankCodeChangeLocked().subscribe(isLocked => {
                if (isLocked) {
                    this.smsMode = true;
                    this.smsModeChange.emit(this.smsMode);
                    this.modalService.sendSmsCode();
                    this.changePasswordForm.controls['SmsCode'].setValue('');
                }
                else {
                    this.userService.changePassword(this.changePasswordForm.value.currentPassword,
                        this.changePasswordForm.value.newPassword).subscribe(result => {
                            this.changePasswordFormSuccess = true;
                            this.initFormGroup(this.changePasswordForm, {
                                currentPassword: '',
                                newPassword: '',
                                newPasswordConfirmation: ''
                            });

                            this.untouchFormGroup(this.changePasswordForm);
                        });
                }
            });
        }
    }

    back() {
        this.smsMode = false;
        this.smsModeChange.emit(this.smsMode);
    }

    confirmWithSms() {
        this.touchFormGroup(this.changePasswordForm);

        if (this.changePasswordForm.valid) {
            this.changePasswordFormSuccess = false;
            let code = this.changePasswordForm.controls['SmsCode'].value;
            this.userService.changePassword(this.changePasswordForm.value.currentPassword,
                this.changePasswordForm.value.newPassword, code).subscribe(result => {
                    this.changePasswordFormSuccess = true;
                    this.initFormGroup(this.changePasswordForm, {
                        currentPassword: '',
                        newPassword: '',
                        newPasswordConfirmation: ''
                    });

                    this.untouchFormGroup(this.changePasswordForm);
                }, (error) => {
                    this.changePasswordFormSuccess = false;
                    this.errorMessageId = error.messageId;
                });
            this.smsMode = false;
            this.smsModeChange.emit(this.smsMode);
            this.changePasswordForm.controls['SmsCode'].setValue('');
        }
    }

    public validateCurrentPassword(): AsyncValidatorFn {
        return (control: FormControl) => {
            var result = new Promise(resolve => {
                if (control.value === "") {
                    resolve(null);
                }
                else {
                    this.userService.verifyPassword(control.value).subscribe(valid => {
                        if (!valid) {
                            resolve({
                                validateCurrentPassword: true
                            });
                        } else {
                            resolve(null);
                        }
                    });
                }
            });

            return result;
        };
    };

    public validatePasswordConfirmation(): ValidatorFn {
        return (control: FormControl) => {
            if (this.changePasswordForm) {
                if (this.changePasswordForm.value.newPassword === control.value) {
                    return null;
                }

                return {
                    validatePasswordConfirmation: true
                };
            }

            return null;
        };
    }
}
